import { render, staticRenderFns } from "./PreferenceModal.vue?vue&type=template&id=4ca4060a&scoped=true"
import script from "./PreferenceModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreferenceModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PreferenceModal.vue?vue&type=style&index=0&id=4ca4060a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca4060a",
  null
  
)

export default component.exports